
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { FolderItemProps } from ".";
import { loading, endLoading, remove } from "store/folder";

interface ApiFolderRemoveInputProps {
    ids: number[]
}

type ApiFolderRemoveOutputProps = OutputBaseProps<{ item: FolderItemProps; }>;

export const apiFolderRemove = async (data: ApiFolderRemoveInputProps) => {
    store.dispatch(loading());
    const res = (await axios.delete<ApiFolderRemoveOutputProps>("/api/folder/remove", { data }))
        .data;
    if (res.code === 0) {
        store.dispatch(remove(data));
    }
    store.dispatch(endLoading());
    return res;
};